import React, { useState, useEffect } from 'react'
import { db } from './../../Firebase'
function Poblacion() {
    //Data
    const [data, setData] = useState(null)
    // Get data from firebase
    useEffect(() => {
        db.collection('Pruebas').doc('FMI2').collection("componentePobreza").doc("data")
            .onSnapshot(snapshot => {
                setData(snapshot.data())
            }
            )
    }, [])
    return (
        <div className="paragraphs">
            {data && (
                <p>
                    Colombia es el tercer país más poblado de Latinoamérica con <strong> {String(data.pob.Value).replace(".", ",")} millones de habitantes </strong>en {data.pob.Year}.
                </p>
            )}

        </div>
    )
}

export default Poblacion
